import React from 'react';
import { Stack } from '@mui/material';
import MaterialBox from '../../../../components/MaterialBox';
import MaterialTypography from '../../../../components/MaterialTypography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const VerticalStepper = ({ steps, activeStep, setActiveStep }) => {
    return (
        <MaterialBox>
            <Stack spacing={0}>
                {steps.map((step, index) => {
                    const isCompleted = index < activeStep;
                    const isActive = index === activeStep;
                    const isLast = index === steps.length - 1;

                    return (
                        <Stack key={index} direction="row" spacing={1} sx={{ position: 'relative' }}>
                            <Stack alignItems="center" sx={{ position: 'relative' }}>
                                <MaterialBox
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    width="28px"
                                    height="28px"
                                    sx={{ zIndex: 1 }}
                                >
                                    {isCompleted ? (
                                        <CheckCircleIcon sx={{ color: '#4caf50', fontSize: '28px', transition: 'all 0.3s ease' }} />
                                    ) : (
                                        <RadioButtonUncheckedIcon
                                            sx={{
                                                color: isActive ? '#3F51B5' : '#b9b8ba',
                                                fontSize: '28px',
                                                transition: 'all 0.3s ease'
                                            }}
                                        />
                                    )}
                                </MaterialBox>
                                {!isLast && (
                                    <div
                                        style={{
                                            width: '2px',
                                            height: '30px',
                                            backgroundColor: index < activeStep ? '#4caf50' : '#e0e0e0',
                                            transition: 'background-color 0.4s ease',
                                            marginTop: '-2px',
                                            marginBottom: '-2px'
                                        }}
                                    />
                                )}
                            </Stack>
                            <MaterialBox
                                sx={{
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    '&:hover': { transform: 'translateX(5px)' }
                                }}
                                onClick={() => setActiveStep(index)}
                            >
                                <MaterialTypography
                                    variant="button"
                                    fontWeight={isActive ? "bold" : "regular"}
                                    color={isActive ? "info" : "text"}
                                    sx={{
                                        fontSize: '0.95rem',
                                        whiteSpace: 'nowrap',
                                        textTransform: 'none',
                                        display: 'block',
                                        lineHeight: '28px',
                                        color: isActive ? '#3F51B5' : '#67748e',
                                    }}
                                >
                                    {step}
                                </MaterialTypography>
                            </MaterialBox>
                        </Stack>
                    );
                })}
            </Stack>
        </MaterialBox>
    );
};

export default VerticalStepper;
